import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { EndpointParams, PaymentMethod, StringDto } from '@models/index';
import { HttpService } from '@services/index';
import { Payment } from '@models/index';
import { PaymentMethodVisibility } from '@enumerates/index';

@Injectable({
    providedIn: 'root'
})
export class PaymentsService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private readonly paymentsSubject = new BehaviorSubject<Payment[]>([]);
    private readonly isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private readonly dataStore: { payments: Payment[] } = { payments: [] };

    readonly payments = this.paymentsSubject.asObservable();
    readonly isLoading = this.isLoadingDataSubject.asObservable();

    list(): void {
        this.loading(true);
        this.listPayments().subscribe(
            () => {
                this.next();
                this.loading(false);
            }
        );
    }

    search(idTransaction: string): Observable<Payment> {
        return this.get(`payments/member/${idTransaction}`, this.defaultEndpointParams).pipe(
            map(response => new Payment().build(response))
        );
    }

    getContractingConditions(idTransaction: string): Observable<StringDto> {
        return this.get(`payments/member/${idTransaction}/contracting-conditions`, this.defaultEndpointParams)
            .pipe(switchMap(res => this.http.get<StringDto>(res.value)));
    }

    getPaymentMethods(visibility: PaymentMethodVisibility): Observable<PaymentMethod[]> {
        return this.get(`paymentmethod/member/${visibility}`, this.defaultEndpointParams);
    }

    getReceipt(idTransaction: string): Observable<StringDto> {
        return this.get(`payments/member/${idTransaction}/receipt`, this.defaultEndpointParams);
    }

    sendReceiptEmail(idTransaction: string): Observable<void> {
        return this.get(`payments/member/${idTransaction}/receipt/email`, this.defaultEndpointParams, null, this.showSuccessMessage('sended_email'));
    }

    private listPayments(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('payments/member', this.defaultEndpointParams).subscribe(
                    data => {
                        this.dataStore.payments = [];
                        data.forEach((payment: any) => {
                            if (payment.price > 0) {
                                this.dataStore.payments.push(new Payment().build(payment));
                            }
                        });

                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(): void {
        this.paymentsSubject.next([...this.dataStore.payments]);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
